/**
 * Created by hu on 2017/3/17.
 * modify by alex.ye 2019/01/18
 * key值不需要 v- 开头，vue默认会加上
 */
import permDirective from './permDirective'
export default{
    "perm": permDirective.perm,
}
